export function getCircleOffsetByRadiusAndStrokeWidth(radius: number, strokeWidth: number) {
    return radius + strokeWidth * 0.5;
}
